import {Component, Input} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AdditionalProcessorFormGroup} from '@em/shared/mapping-engine/domain-models';
import {EmBoxModule, EmIconButtonComponent} from '@em/shared/ui';
import {EmFindReplaceComponent} from '../find-replace/find-replace.component';

@Component({
  selector: 'em-additional-processor',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    EmFindReplaceComponent,
    EmBoxModule,
    EmIconButtonComponent,
  ],
  templateUrl: './additional-processor.component.html',
  styleUrls: ['./additional-processor.component.scss'],
})
export class EmAdditionalProcessorComponent {
  @Input() processorFormGroup?: AdditionalProcessorFormGroup;

  get findReplaceGroup() {
    return this.processorFormGroup?.controls?.find_replace;
  }

  removeFindReplace() {
    this.processorFormGroup?.removeControl('find_replace');
  }
}
